import { Tooltip as ReactTooltip } from "react-tooltip";
import { getTooltipClassName } from "../../../../utils";

interface MessageSuggestionButtonProps {
  question: string;
  onClick: () => void;
  isDarkMode: boolean;
}

export function MessageSuggestionButton({
  question,
  onClick,
  isDarkMode,
}: MessageSuggestionButtonProps) {
  return (
    <div className="MessageSuggestionButton grid grid-cols-[auto_1fr] gap-2 md:gap-3 min-w-0">
      {/* Empty avatar space for alignment */}
      <div className="w-8 h-8" />
      <div className="min-w-0">
        <span className="text-purple-400 font-xs!">Maybe you want to ask:</span>
        <button
          type="button"
          onClick={onClick}
          className={`message-suggestion-btn
            w-full text-left rounded-lg! px-4 py-2.5 transition-all duration-200            
            border-purple-400!            
            border-2!
            shadow-purple-300!
            shadow-xs!
            animate-pulse-shadow!
            ${
              isDarkMode
                ? "bg-gray-800 border-gray-600 text-gray-300 hover:bg-gray-700 hover:border-gray-500"
                : "bg-gray-100 border-gray-300 text-gray-700 hover:bg-gray-200 hover:border-gray-400"
            }
            hover:shadow-md!
            focus:outline-none focus:ring-2 focus:ring-offset-2
            ${isDarkMode ? "focus:ring-gray-500" : "focus:ring-gray-400"}
          `}
        >
          <div className="grid grid-cols-[1fr_auto] items-center gap-2">
            <span className="text-sm font-medium">{question}</span>
            <svg
              className={`w-4 h-4 ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </button>
        <ReactTooltip
          anchorSelect=".message-suggestion-btn"
          place="top"
          content={"Click to send this message"}
          className={getTooltipClassName(isDarkMode)}
        />
      </div>
    </div>
  );
}
